export const TENANT_INACTIVE_CODE = 'tenant_inactive';
export const TENANT_INACTIVE_PATH = '/tenant-inactive';

interface ErrorWithResponse {
  response?: { status?: number; data?: unknown };
}

export function isTenantInactiveError(error: ErrorWithResponse | null | undefined): boolean {
  const response = error?.response;
  if (response?.status !== 403) return false;
  const data = response.data as { code?: unknown } | null | undefined;
  return data?.code === TENANT_INACTIVE_CODE;
}

// A full navigation, not a router push: the notice page sits outside the app
// layout, so nothing on it keeps polling the API.
export function showTenantInactiveNotice(): void {
  if (window.location.pathname !== TENANT_INACTIVE_PATH) {
    window.location.assign(TENANT_INACTIVE_PATH);
  }
}
